<template>
  <div id="propertyZone">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            社區代訂專區
          </div>
          <div class="tip">
            給好夥伴專屬的好康資訊
          </div>
        </div>
      </div>
      <section>
        <advertise id="ad" />
      </section>
    </div>
  </div>
</template>

<script>
import advertise from './components/advertise'
export default {
  components: {
    advertise
  }
}
</script>

<style lang="sass" scoped>
#propertyZone
  padding: 50px 0 10px
  height: 100%
  .main
    min-width: 1140px
    max-width: 90%
    margin: 0 auto
    padding: 30px
    color: $mainFontColor
    background-color: #fff
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
    border-radius: $pageBorderRadius
    box-sizing: border-box
    .title_bar
      display: flex
      justify-content: space-between
      align-items: center
      margin: 0 0 20px 0
      .title
        font-weight: bold
        font-size: map-get($fontSize,xx-large)
        margin-bottom: 10px
        text-align: left
      .tip
        font-size: map-get($fontSize,small)
        color: $subFontColor
</style>
